module.exports = __webpack_public_path__ + "static/booking-hero-f86cee3b98355d8540ca5d2201ddf203.png";